import { render, staticRenderFns } from "./OrganismResetPassword.vue?vue&type=template&id=b95fbb14"
import script from "./OrganismResetPassword.vue?vue&type=script&lang=js"
export * from "./OrganismResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports